import { render, staticRenderFns } from "./PublicPartnerships.vue?vue&type=template&id=18237e42&"
import script from "./PublicPartnerships.vue?vue&type=script&lang=js&"
export * from "./PublicPartnerships.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports